import React from "react";
import "./index.css";
import logo1 from "./images/about1.jpg";
import logo2 from "./images/about2.jpg";
import logo3 from "./images/about3.jpg";
import logo4 from "./images/logo4.jpg";
import logo5 from "./images/logo5.jpg";
import logo6 from "./images/logo6.png";

const About = () => {
  const highlights = [
    {
      image: logo1,
      title: "Manufacturing Experience",
      description: "We have 5 years of experience in a large manufacturing company from logistics to processing and distribution departments and most agricultural businesses and many more."
    },
    {
      image: logo6,
      title: "NEBOSH Certified",
      description: "Our team is NEBOSH certified, ensuring the highest standards of health and safety expertise for your business."
    },
    {
      image: logo2,
      title: "Personalized Consultations",
      description: "We offer competent advice with Zoom conference calls one-on-one. No business is too small or large. Feel free to call for a quote with no obligations."
    },
    {
      image: logo3,
      title: "Risk Assessment",
      description: "Legal, moral and financial risk assessment reviews to keep your business compliant and your employees safe."
    }
  ];

  return (
    <section id="about">
      <div className="main-head">
        <div className="heading">
          <h1>About Us</h1>
        </div>
        <div className="para">
          <p>
            We aim to create a better and safer environment for employees
            and employers across all types of businesses. We also help organizations
            build better culture and unlock more benefits by implementing Health
            and Safety within their business structure.
          </p>
          <p>
            We are competent, certified professionals — Chartered and members of IOSH. 
            With 5 years of experience in large manufacturing companies spanning 
            logistics, processing, distribution, and agricultural businesses, 
            we bring practical expertise to every consultation.
          </p>
          <p>We specialize in construction and fire safety.</p>
        </div>
      </div>

      <div className="abt-content">
        {highlights.map((item, index) => (
          <div className="aboutcard" key={index}>
            <div className="aboutbox">
              <div className="imagee">
                <img src={item.image} alt={item.title} />
              </div>
              <h3 style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                color: '#0a0a0a',
                marginBottom: '0.75rem'
              }}>
                {item.title}
              </h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <section>
        <div className="lastimg">
          <img
            src={logo4}
            alt="Certificate"
            className="left"
          />
          <img
            src={logo5}
            alt="Certificate"
            id="logo5"
            className="right"
          />
        </div>
      </section>
    </section>
  );
};

export default About;
